<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loading="loading" :disabled="loading">
        <v-card-title class="subtitle-1">
          Reativação de linha suspensa
        </v-card-title>
        <v-card-text>
          <div class="d-flex align-center">
            <v-btn class="mr-2" color="primary" @click="clickAddNewLine()">Selecionar linha</v-btn>
            <v-btn v-if="groupUser === 1 || groupUser === 2" color="success" @click="showModalImport = true"><v-icon left>mdi-database-import</v-icon>Importar arquivo</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      md="6"
      sm="12"
      v-for="(lineSelected, index) in lineSelect"
      :key="index"
    >
      <v-card outlined class="mx-auto">
        <v-card-title class="primary white--text" :title="'Reativação de linha suspensa'">
          <div class="headerClass">
            {{lineSelected.line && lineSelected.line.ddi ? lineSelected.line.ddi+' ('+lineSelected.line.ddd+') '+lineSelected.line.nr_linha : 'Selecione uma linha' }}
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeLine(index)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="card-text-scroll">
          <v-row>
            <v-col cols="12">
              <LineComponent
                :rules="[v => (v && Object.keys(v).length > 0) || 'Obrigatório']"
                :suspendLines="true"
                :selectedLine="lineSelected.line"
                @save="
                  lineSelected.line = $event;
                  updateSelectedLine($event, lineSelected, index);
                "
              ></LineComponent>
            </v-col>
            <ListPackage
                v-if="loadingLinePackages[index]"
                :loadingPackage="loadingLinePackages[index].value"
                :lineSelected="lineSelected"
            >
            </ListPackage>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <ImportDataSolicitationDialogComponent
      v-if="showModalImport"
      :title="'Linhas Identificadas'"
      :automation="AUTOMATION_REACTIVATE_LINE()"
      @closeDialog="showModalImport = false"
      @importValues="importValues($event)"
    ></ImportDataSolicitationDialogComponent>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import ListPackage from "@/components/package/ListPackage";
import LineComponent from "@/components/forms/LineComponent.vue";
import ImportDataSolicitationDialogComponent from "@/components/dialog/ImportDataSolicitationDialogComponent.vue";
import isEmpty from "lodash/isEmpty";
import { AUTOMATION_REACTIVATE_LINE } from "../../helpers/constants";
export default {
  components: { ImportDataSolicitationDialogComponent, LineComponent, ListPackage},
  props: {
    groupUser: {},
    index: {},
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lineSelect: [],
      loading: true,
      maxLength: 50,
      showModalImport: false,
      show: false,
      lineRules: [v => !!v || "Linha é obrigatório"],
      loadingLinePackages: []
    };
  },
  async mounted() {
    const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
    if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
      this.resultStorage = dataLocalStorage;
      this.lineSelect = Object.assign([], this.resultStorage);
      this.lineSelect.forEach(value => {
        this.loadingLinePackages.push({ value: false });
      });
    } else {
      await this.clickAddNewLine();
    }
    this.loading = false;
  },
  computed: {
    ...mapState("packages", ["lines"]),
    ...mapGetters({
      linePackages: "packages/getLinePackages"
    })
  },
  methods: {
    AUTOMATION_REACTIVATE_LINE() {
      return AUTOMATION_REACTIVATE_LINE
    },
    ...mapActions("packages", ["loadLinePackages"]),
    ...mapActions("solicitation", ["loadDataLocalStorage"]),
    ...mapMutations({
      setModel: "forms/setModelReactivateLine"
    }),
    importValues(data) {
      const normalizeId = id => String(id);
      const existingIds = new Set(this.lineSelect.map(item => normalizeId(item.line.id_linha)));
      const filtered = data
        .filter(item => !existingIds.has(normalizeId(item.line.id_linha)))
        .map(item => ({
          packages: item.packages,
          line: item.line
        }));

      this.lineSelect.push(...filtered);
      this.updateValues(this.lineSelect);
      this.lineSelect.forEach(value => {
        this.loadingLinePackages.push({ value: false });
      });
      this.showModalImport = false;
    },
    async clickAddNewLine() {
      if (this.lineSelect.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        const newLine = {
          packages: [],
          line: {}
        };

        this.loadingLinePackages.push({
          value: false
        });

        this.lineSelect = [newLine, ...this.lineSelect];
        this.updateValues();
      }
    },
    async updateSelectedLine(line, lineSelected, index) {
      this.show = this.show ? false : lineSelected;
      this.loadingLinePackages[index].value = true;
      if (line.id_linha) {
        lineSelected.packages = [];
        await this.loadLinePackages({
          id_linha: line.id_linha,
          type: 'suspend'
        }).catch(
          error => {
            this.$swal("Oops...", error.message, "error");
          }
        );
        lineSelected.packages = this.linePackages.data;
      }
      this.updateValues();
      this.show = false;
      this.loadingLinePackages[index].value = false;
    },
    updateValues() {
      const payload = {
        step: this.index,
        selected: {
          model: { lines: this.lineSelect},
          revision: { lines: this.lineSelect}
        }
      };
      this.setModel(payload);
      if (this.page === 'wizard') {
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(this.lineSelect));
      }
    },
    closeLine(index) {
      if (index > -1) {
        this.lineSelect.splice(index, 1);
        this.loadingLinePackages.splice(index, 1);
        this.updateValues();
      }
    },
    customFilter(item, queryText) {
      queryText = queryText.replace(/[\s()\-/]/g, '');
      const regExp = new RegExp(queryText, 'i')
      const phoneNumber = item.ddi + item.ddd + item.nr_linha;
      return (
          regExp.test(phoneNumber) || regExp.test(item.nome_completo.replace(/\s/g, ''))
      );
    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-text-scroll {
  max-height: 400px;
  overflow-y: auto;
}
</style>
